/* eslint-disable react/prop-types */ // TODO: add props
import LessonUtils from 'edrolo/utils/LessonUtils';
import LessonNavItem from './LessonNavItem';
import s from './styles.scss';

export const LessonNav = ({ chunks, chunkVisits, buildChunkUrl }) => {
  const groups = LessonUtils.groupChunks(chunks);

  return (
    <div className={s.lessonNav} data-test="lesson-nav">
      <ul>
        {groups.map((chunks, i) => (
          <LessonNavItem
            key={i}
            chunkVisits={chunkVisits}
            chunks={chunks}
            buildChunkUrl={buildChunkUrl}
          />
        ))}
      </ul>
    </div>
  );
};
